
import { Item } from "@dndModels/item/ItemModel";

export class BasicItem extends Item {
  tool_id = ""; // Move this to Tool
  stackable = false;
  bundle_size = 1;
  worn_type = "None"; 
  
  // If it is worn and can't be worn with something else 
  // of the same type then put it here.  
  // Hat, Goggles, Gloves, BasicItem, Boots, Clothing, Cape/Cloak

  constructor(obj?: any) {
    super(obj);
    if (obj) {
      this.item_type = obj.item_type ? obj.item_type : "Other";

      this.tool_id = obj.tool_id ? obj.tool_id : "";
      
      this.stackable = obj.stackable ? obj.stackable : false;
      this.bundle_size = obj.bundle_size ? +obj.bundle_size : 1;
      this.worn_type = obj.worn_type ? obj.worn_type : "None";
      
      if (this.bundle_size === 0) {
        this.bundle_size = 1;
      }
    }
  }

  // load(obj: any): void {
  //   super.load(obj);
  //   if (obj) {
  //     this.item_type = obj.item_type ? obj.item_type : "Other";

  //     this.tool_id = obj.tool_id ? obj.tool_id : "";
      
  //     this.stackable = obj.stackable ? obj.stackable : false;
  //     this.bundle_size = obj.bundle_size ? +obj.bundle_size : 1;
  //     this.worn_type = obj.worn_type ? obj.worn_type : "None";
      
  //     if (this.bundle_size === 0) {
  //       this.bundle_size = 1;
  //     }
  //   }
  // }

  toDBObj(): any {
    const base_db_obj = super.toDBObj();
    return {
      ...base_db_obj,
      item_type: this.item_type,
      weight: this.weight,
      tool_id: this.tool_id,
      stackable: this.stackable,
      bundle_size: this.bundle_size,
      cost: this.cost,
      worn_type: this.worn_type
    };
  }

  toLight(): any {
    const base_db_obj = super.toLight();
    return {
      ...base_db_obj,
      item_type: this.item_type,
      weight: this.weight,
      tool_id: this.tool_id,
      stackable: this.stackable,
      bundle_size: this.bundle_size,
      cost: this.cost,
      worn_type: this.worn_type
    };
  }

  clone(drop_ids = false): BasicItem {
    const new_obj = new BasicItem();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }

  copy(copyMe: BasicItem, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    this.item_type = copyMe.item_type;
    this.b_weight = copyMe.b_weight;
    this.cost = copyMe.cost;
    // this.magical = copyMe.magical;
    this.tool_id = copyMe.tool_id;
    this.stackable = copyMe.stackable;
    this.bundle_size = copyMe.bundle_size;
    this.worn_type = copyMe.worn_type;
  }
}